module.exports = __webpack_public_path__ + "static/media/illustration-referror.9154c27a.png";